import { createContext, useContext } from 'react';
import type { AIHookResult } from './AIWrapper';

interface AIWrapperContextValue {
  aiHook: AIHookResult;
  value: string;
  onChange?: (value: string) => void;
  showTypingEffect: boolean;
}

const AIWrapperContext = createContext<AIWrapperContextValue | null>(null);

export function useAIWrapperContext() {
  const context = useContext(AIWrapperContext);
  if (!context) {
    throw new Error('useAIWrapperContext must be used within AIWrapper');
  }
  return context;
}

export { AIWrapperContext };
